"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
require("./modal.scss");
var button_component_1 = require("../buttons/button_component");
var CustomModel = function (_a) {
    var children = _a.children, _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, sx = _a.sx, _c = _a.showCloseButton, showCloseButton = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: "modal-component" },
        React.createElement(material_1.Dialog, { open: open, onClose: onClose, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description", PaperProps: {
                sx: __assign({ borderRadius: '24px', padding: '32px', minWidth: '492px', maxWidth: '728px', maxHeight: '700px' }, sx),
            } },
            React.createElement(material_1.DialogContent, { sx: { padding: 0 } }, children),
            React.createElement(material_1.Box, { className: 'close-btn-wrapper' },
                React.createElement(button_component_1.default, { buttonName: 'Close', color: 'yellow', onClickHandler: onClose, sx: { textAlign: 'end', marginTop: '15px' } })))));
};
exports.default = CustomModel;
